export type FAQItem = {
  id: string;
  question: string;
  answer: string;
  topic?: string;
};

export type ContentSection = {
  title?: string;
  paragraphs: string[];
};

export const FAQ_DATA: FAQItem[] = [
  {
    id: "1",
    question: "How do I set up my kitchen on Duddus?",
    answer:
      "Complete the onboarding steps: outlet details, location, operational hours, delivery configuration, legal documents, bank details, and photos. Once submitted, our team reviews your kitchen before it goes live.",
    topic: "Restaurant",
  },
  {
    id: "2",
    question: "How do I add and manage dishes?",
    answer:
      "Go to the Dish tab and tap Add New Dish. Fill in basic info, classification, pricing, operations, and channel availability. You can edit or update availability anytime from your dish list.",
    topic: "Menu",
  },
  {
    id: "3",
    question: "How do I receive and accept orders?",
    answer:
      "New orders appear in the Orders tab and as a notification. Review the items and accept or reject within the allotted time. After accepting, update the order status as you prepare and dispatch.",
    topic: "Order Related issues",
  },
  {
    id: "4",
    question: "How do payouts and wallet work?",
    answer:
      "Earnings from completed orders are reflected in My Wallet. You can view transactions and payout status from Payouts under Kitchen Profile.",
    topic: "Payments",
  },
  {
    id: "5",
    question: "How do I create discounts and coupons?",
    answer:
      "Open Kitchen Profile → Discounts and Coupons, then add a new coupon with discount type, value, validity, and usage limits. Active coupons are applied automatically when customers meet the conditions.",
    topic: "Business growth",
  },
  {
    id: "6",
    question: "How do I update outlet information?",
    answer:
      "Go to Kitchen Profile → Outlet Information to view your current details. Tap edit to update contact info, address, timings, and other outlet settings.",
    topic: "Location and address",
  },
  {
    id: "7",
    question: "How are taxes handled on orders?",
    answer:
      "Tax is calculated on each order as per your GST details submitted during onboarding. You can review tax amounts on individual order details and in sales reports.",
    topic: "Taxes",
  },
  {
    id: "8",
    question: "What hygiene standards should kitchens follow?",
    answer:
      "Keep a valid FSSAI license, maintain kitchen cleanliness, store food safely, and update your legal documents from Outlet Information whenever they are renewed.",
    topic: "Hygiene and health",
  },
];

export const ABOUT_US: ContentSection[] = [
  {
    paragraphs: [
      "Duddus Kitchen is the partner app for restaurants and cloud kitchens on the Duddus platform — manage your menu, orders, coupons, and payouts from one place.",
    ],
  },
  {
    title: "Our Mission",
    paragraphs: [
      "We help kitchens grow by connecting them with hungry customers, simplifying daily operations, and giving partners the tools to run delivery and dine-in seamlessly.",
    ],
  },
  {
    title: "What We Offer",
    paragraphs: [
      "Real-time order management, menu controls, discounts, wallet payouts, and performance insights — built for busy kitchen teams.",
      "Whether you run a single outlet or multiple kitchens, Duddus Kitchen keeps your operations organised and your customers delighted.",
    ],
  },
  {
    title: "Contact Us",
    paragraphs: [
      "Need help getting started or have feedback? Reach us anytime through Help Center. We are here to support our kitchen partners.",
    ],
  },
];
